import React from 'react';
import { useParams } from 'react-router-dom';
import { CustomerDecisionOptionsType, ProductItem, ExpectedAlternativeProductData } from "./AlternativeOfferModal";
import * as translator from "../../../utils/translator";

type Props = {
    customerSelection: CustomerDecisionOptionsType;
    onCustomerChoiceChange: (originalProductItemID: number, alternativeProductItemID: CustomerDecisionOptionsType) => void;
    originalProduct: ProductItem;
    alterantiveProduct: ExpectedAlternativeProductData;
    isOutOfStockFlow: boolean
}

export const CustomerChangeDecisionCard: React.FC<Props> = ({
    customerSelection,
    onCustomerChoiceChange,
    originalProduct,
    alterantiveProduct,
    isOutOfStockFlow
}) => {
    const { country } = useParams();
    
    const getdecisionTranslationsKey = (key: CustomerDecisionOptionsType) => {
        switch (key) {
            case "WAIT_FOR_RESTOCK_OF_ORIGINAL_PRODUCT":
                return "wait_10_days_button";
            case "REJECT_ALTERNATIVE":
                return "cancled";
            default:
                return "accepted";
        }
    }

    const descitionTranslationKey = getdecisionTranslationsKey(customerSelection);
    
    return (
        <div className="customer-change-decision-card">
            <div className="product-img-container">
                <img
                    src={alterantiveProduct ? alterantiveProduct.imageSrc : originalProduct.imageSrc}
                    alt="Product"
                    className={`product-img ${!alterantiveProduct ? 'product-img-out-of-stock' : ''}`}
                />
            </div>

            {!isOutOfStockFlow && 
            <p className="title-view">
                {alterantiveProduct ? alterantiveProduct.titleView : translator.translate(translator.getLanguageByCountry(country), "my_account", "MyOrders/details/alternative_offer_modal/alternative_product_not_found")}
            </p>
            }

            <p className={`${isOutOfStockFlow ? 'alternative-for-out-of-stock' : 'alternative-for'}`}>
                {isOutOfStockFlow ? "" : translator.translate(translator.getLanguageByCountry(country), "my_account", "MyOrders/details/alternative_offer_modal/alternative_for")}
                <span className="alternative-for-original-product-name"> {originalProduct.title}</span>
            </p>

            <div className="current-decision-control-container">
                {/* display of the current decision made by the customer */}
                <span className={`current-decision ${descitionTranslationKey}`}>{translator.translate(translator.getLanguageByCountry(country), "my_account", `MyOrders/details/alternative_offer_modal/${descitionTranslationKey}`)}</span>

                {/* option to change the decision */}
                <button
                    className="change-decision-action-button"
                    onClick={() => onCustomerChoiceChange(originalProduct.product_item_id, null)}
                >
                    {translator.translate(translator.getLanguageByCountry(country), "my_account", "MyOrders/details/alternative_offer_modal/change_decision")}
                </button>
            </div>
        </div>
    );
} 